import { render } from "./SettingsListItem.vue?vue&type=template&id=6cf14d6a&scoped=true"
import script from "./SettingsListItem.vue?vue&type=script&lang=ts"
export * from "./SettingsListItem.vue?vue&type=script&lang=ts"

import "./SettingsListItem.vue?vue&type=style&index=0&id=6cf14d6a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6cf14d6a"

export default script